module.exports = __webpack_public_path__ + "static_pc/img/4.27683876.png";